var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7499 11.9168C13.243 11.9168 12.8333 12.3275 12.8333 12.8334V16.5002C12.8333 17.0052 12.4225 17.4168 11.9165 17.4168H9.16651V3.66691C9.16651 2.88408 8.66785 2.18467 7.91808 1.92434L7.64668 1.83354H11.9165C12.4225 1.83354 12.8333 2.24509 12.8333 2.75031V5.50028C12.8333 6.00616 13.243 6.41688 13.7499 6.41688C14.2567 6.41688 14.6665 6.00616 14.6665 5.50028V2.75031C14.6665 1.23416 13.4326 0.000335693 11.9165 0.000335693H2.06248C2.02757 0.000335693 1.99836 0.0159453 1.96446 0.0204771C1.92031 0.0167845 1.87818 0.000335693 1.83337 0.000335693C0.822272 0.000335693 0 0.82244 0 1.83354V18.3334C0 19.1162 0.498667 19.8156 1.24843 20.0759L6.76499 21.9148C6.95197 21.9726 7.13794 22.0001 7.33331 22.0001C8.34441 22.0001 9.16651 21.1778 9.16651 20.1667V19.2501H11.9165C13.4326 19.2501 14.6665 18.0163 14.6665 16.5002V12.8334C14.6665 12.3275 14.2567 11.9168 13.7499 11.9168Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7312 8.51875L18.0645 4.85217C17.8025 4.59 17.4082 4.51111 17.0655 4.65311C16.7236 4.79527 16.4998 5.12979 16.4998 5.50022V8.25019H12.8333C12.3272 8.25019 11.9165 8.66074 11.9165 9.16679C11.9165 9.67285 12.3272 10.0834 12.8333 10.0834H16.4998V12.8334C16.4998 13.2038 16.7236 13.5383 17.0655 13.6805C17.4082 13.8225 17.8025 13.7436 18.0645 13.4816L21.7312 9.81484C22.0896 9.45649 22.0896 8.87709 21.7312 8.51875Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c91c1543b015109da1bced83916a3d5b.svg";
export { ForwardRef as ReactComponent };